import { render, staticRenderFns } from "./StdItemTxtList.vue?vue&type=template&id=1c121766&"
import script from "./StdItemTxtList.vue?vue&type=script&lang=js&"
export * from "./StdItemTxtList.vue?vue&type=script&lang=js&"
import style0 from "./StdItemTxtList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdItemTxtList.vue"
export default component.exports